/**
 * Cart Drawer Improvements
 * 1. Override add-to-cart to open drawer instead of redirecting to cart page
 * 2. Fix quantity updates in cart drawer to refresh totals
 */

(function() {
  'use strict';

  /**
   * Override the default add-to-cart behavior to open cart drawer
   */
  function initAddToCartDrawerBehavior() {
    // Find all add-to-cart forms
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]');
    
    addToCartForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        handleAddToCartSubmission(form);
      });
    });

    // Also handle custom add-to-cart elements
    const customAddToCartElements = document.querySelectorAll('add-to-cart');
    customAddToCartElements.forEach(element => {
      const form = element.querySelector('form');
      if (form) {
        // Remove existing event listeners and add our own
        const newForm = form.cloneNode(true);
        form.parentNode.replaceChild(newForm, form);
        
        newForm.addEventListener('submit', function(e) {
          e.preventDefault();
          handleAddToCartSubmission(newForm);
        });
      }
    });
  }

  /**
   * Handle add to cart form submission
   */
  function handleAddToCartSubmission(form) {
    const formData = new FormData(form);
    const glueCheckbox = document.querySelector('#add-glue-checkbox');
    const shouldIncludeGlue = glueCheckbox && glueCheckbox.checked;
    
    // Get form data
    const variantId = formData.get('id');
    const quantity = formData.get('quantity');
    
    // Build items array
    const items = [{
      id: variantId,
      quantity: quantity,
      properties: {}
    }];

    // Add properties if they exist
    const properties = ['Dimenzije', '_product_code', '_height', '_width'];
    properties.forEach(prop => {
      const value = formData.get(`properties[${prop}]`);
      if (value) {
        items[0].properties[prop] = value;
      }
    });

    // Add glue product if checked
    if (shouldIncludeGlue) {
      const glueProductId = (window.theme && window.theme.glueProductId) || "46186342482137";
      items.push({
        id: glueProductId,
        quantity: 1
      });
    }

    // Add items to cart via AJAX
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status && (data.status.toString()[0] === '4' || data.status.toString()[0] === '5')) {
        console.error('Error adding items to cart:', data);
        return;
      }
      
      // Success - refresh cart drawer content and open it
      refreshCartDrawer().then(() => {
        openCartDrawer();
      });
    })
    .catch(error => {
      console.error('Error adding items to cart:', error);
    });
  }

  /**
   * Refresh cart drawer content
   */
  function refreshCartDrawer() {
    return fetch(`${window.routes.localeRootUrl}/?section_id=cart-drawer`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');
        
        if (newCartDrawer) {
          const currentCartDrawer = document.querySelector('cart-drawer');
          if (currentCartDrawer) {
            // Update the inner content
            const newInnerContent = newCartDrawer.querySelector('.drawer__inner');
            const currentInnerContent = currentCartDrawer.querySelector('.drawer__inner');
            if (newInnerContent && currentInnerContent) {
              currentInnerContent.innerHTML = newInnerContent.innerHTML;
              
              // Re-initialize cart drawer items component after content update
              reinitializeCartComponents();
            }
          }
        }

        // Update cart bubble count if it exists
        updateCartBubble();
      });
  }

  /**
   * Re-initialize cart components after dynamic content update
   */
  function reinitializeCartComponents() {
    // Re-initialize cart-drawer-items component
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && cartDrawerItems.connectedCallback) {
      cartDrawerItems.connectedCallback();
    }

    // Re-initialize cart-remove-button components
    const removeButtons = document.querySelectorAll('cart-remove-button');
    removeButtons.forEach(button => {
      if (button.connectedCallback) {
        button.connectedCallback();
      }
    });

    // Re-initialize quantity-input components
    const quantityInputs = document.querySelectorAll('cart-drawer quantity-input');
    quantityInputs.forEach(input => {
      if (input.connectedCallback) {
        input.connectedCallback();
      }
    });

    // Dispatch a custom event to let other components know cart was updated
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { source: 'cart-drawer-refresh' }
    }));

    // Fallback: Manually handle remove buttons if components don't re-initialize
    initializeRemoveButtons();
  }

  /**
   * Manually initialize remove button functionality as fallback
   */
  function initializeRemoveButtons() {
    const removeButtons = document.querySelectorAll('cart-drawer cart-remove-button button');
    
    removeButtons.forEach(button => {
      // Remove existing listeners to avoid duplicates
      button.removeEventListener('click', handleRemoveItem);
      // Add new listener
      button.addEventListener('click', handleRemoveItem);
    });
  }

  /**
   * Handle remove item button click
   */
  function handleRemoveItem(e) {
    e.preventDefault();
    
    const removeButton = e.target.closest('cart-remove-button');
    const itemIndex = removeButton.getAttribute('data-index');
    
    if (!itemIndex) {
      console.error('No item index found for remove button');
      return;
    }

    // Remove item by setting quantity to 0
    const updateData = {
      updates: {}
    };
    
    // Find the item by index and set quantity to 0
    const cartItems = document.querySelectorAll('cart-drawer .cart-item');
    const targetItem = Array.from(cartItems).find(item => {
      const quantityInput = item.querySelector('.quantity__input');
      return quantityInput && quantityInput.getAttribute('data-index') === itemIndex;
    });

    if (targetItem) {
      const quantityInput = targetItem.querySelector('.quantity__input');
      const variantId = quantityInput.getAttribute('data-quantity-variant-id');
      
      if (variantId) {
        updateData.updates[variantId] = 0;

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updateData)
        })
        .then(response => response.json())
        .then(() => {
          // Refresh cart drawer content
          refreshCartDrawer();
          // Update cart bubble count
          updateCartBubble();
        })
        .catch(error => {
          console.error('Error removing item from cart:', error);
        });
      }
    }
  }

  /**
   * Update cart icon bubble count
   */
  function updateCartBubble() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartBubbles = document.querySelectorAll('#cart-icon-bubble .cart-count, #cart-icon-bubble-mobile .cart-count');
        cartBubbles.forEach(bubble => {
          if (cart.item_count < 100) {
            bubble.textContent = cart.item_count;
          } else {
            bubble.textContent = '~';
          }
        });
      });
  }

  /**
   * Open cart drawer
   */
  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.open) {
      cartDrawer.open();
    } else {
      // Fallback - trigger click on cart icon
      const cartIcon = document.querySelector('#cart-icon-bubble') || document.querySelector('#cart-icon-bubble-mobile');
      if (cartIcon) {
        cartIcon.click();
      }
    }
  }

  /**
   * Fix cart drawer quantity updates
   */
  function initCartDrawerQuantityFix() {
    // Handle quantity input changes
    document.addEventListener('change', function(e) {
      // Check if the change event is from a cart drawer quantity input
      if (e.target.matches('cart-drawer-items input[name*="updates"]') || 
          e.target.matches('cart-drawer input.quantity__input')) {
        handleQuantityChange(e.target);
      }
    });

    // Handle quantity button clicks (+ and - buttons)
    document.addEventListener('click', function(e) {
      if (e.target.matches('cart-drawer quantity-input button[name="plus"], cart-drawer quantity-input button[name="minus"]')) {
        const quantityInput = e.target.parentElement.querySelector('.quantity__input');
        if (quantityInput) {
          // Wait for the button click to update the input value, then handle the change
          setTimeout(() => {
            handleQuantityChange(quantityInput);
          }, 50);
        }
      }
    });
  }

  /**
   * Handle quantity change for a specific input
   */
  function handleQuantityChange(input) {
    const variantId = input.getAttribute('data-quantity-variant-id');
    const newQuantity = parseInt(input.value);
    
    if (!variantId || isNaN(newQuantity) || newQuantity < 0) {
      return;
    }

    // Update cart via AJAX
    const updateData = {
      updates: {}
    };
    updateData.updates[variantId] = newQuantity;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updateData)
    })
    .then(response => response.json())
    .then(cart => {
      // Update the cart drawer content
      refreshCartDrawer();
      // Update cart bubble count
      updateCartBubble();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      // Revert the input value on error
      location.reload();
    });
  }

  /**
   * Initialize everything when DOM is ready
   */
  function init() {
    initAddToCartDrawerBehavior();
    initCartDrawerQuantityFix();
    initializeRemoveButtons(); // Initialize remove buttons on page load
    
    // Re-initialize when new content is loaded via AJAX
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        initAddToCartDrawerBehavior();
        initializeRemoveButtons();
      }, 100);
    });

    // Also listen for cart updates to re-initialize components
    document.addEventListener('cart:updated', () => {
      setTimeout(() => {
        initializeRemoveButtons();
      }, 100);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
